import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e97633a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2e97633a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e97633a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UpVersionAlert: require('/var/jenkins_home/workspace/b.speedtest.cn/components/upVersionAlert.vue').default})
